import { Component, effect, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Id } from '@turf/turf';
import { Driver, Landmark } from '../../../../database/models';
import { DevicesManagerService, FullDevice } from '../../../../services/devices-manager.service';
import DriversService from '../../../../services/drivers.service';
import LandmarksService from '../../../../services/landmarks.service';
import { ShowIfTruncatedDirective } from '../../../../utils/directives/show-if-truncated.directive';
import DynamicDatePipe from '../../../../utils/pipes/dynamic-date.pipe';
import { ChipComponent } from '../../../history/chip/chip.component';

@Component({
  selector: 'device-card-2',
  templateUrl: './device-card-2.component.html',
  styleUrls: ['./device-card-2.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DynamicDatePipe, ChipComponent, MatIconModule, MatTooltip, ShowIfTruncatedDirective],
})
export class DeviceCard2Component {
  private _landmarksService = inject(LandmarksService);
  private _driversService = inject(DriversService);
  private _devicesManagerService = inject(DevicesManagerService);
  /** Signal input: the effect re-runs when a virtual scroll reuses the card for another device. */
  public uid = input<Id | number>();

  public poi: Landmark | null = null;
  public zoi: Landmark | null = null;
  public driver: Driver | null = null;
  // TODO : need refacto device : transform to reactive device
  public localDevice: FullDevice;

  constructor() {
    effect(() => {
      this.initComponent();
    });
  }

  private initComponent() {
    this.localDevice = this._devicesManagerService.get(this.uid());
    this.poi = null;
    this.zoi = null;
    this.driver = null;

    if (this.localDevice?.poi) this.poi = this._landmarksService.$landmarksById()?.[this.localDevice?.poi];
    if (this.localDevice?.uid_zoi)
      this.zoi = this._landmarksService.$landmarksById()?.[this.localDevice?.uid_zoi];
    if (this.localDevice?.uid_driver)
      this.driver = this._driversService.$valuesRecord()?.[this.localDevice?.uid_driver];
  }
}
